module.exports = __webpack_public_path__ + "img/Indicatordata-checked.e19e28c6.svg";